export default __webpack_public_path__ + "static/media/stonehenge.9c8faee1.jpg";